/* tonton Ranzen-Paten: Anzahl, Karte und Liste der Organisationen, Formular. Keine externen Anfragen. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  // Städte und Gemeinden des Regionalverbands Ruhr (grob über den Ort aus der Adresse)
  var RUHR = ['bochum', 'bottrop', 'dortmund', 'duisburg', 'essen', 'gelsenkirchen', 'hagen', 'hamm', 'herne', 'mülheim', 'oberhausen',
    'alpen', 'dinslaken', 'hamminkeln', 'hünxe', 'kamp-lintfort', 'moers', 'neukirchen-vluyn', 'rheinberg', 'schermbeck', 'sonsbeck', 'voerde', 'wesel', 'xanten',
    'castrop-rauxel', 'datteln', 'dorsten', 'gladbeck', 'haltern', 'herten', 'marl', 'oer-erkenschwick', 'recklinghausen', 'waltrop',
    'bergkamen', 'bönen', 'fröndenberg', 'holzwickede', 'kamen', 'lünen', 'schwerte', 'selm', 'unna', 'werne',
    'breckerfeld', 'ennepetal', 'gevelsberg', 'hattingen', 'herdecke', 'schwelm', 'sprockhövel', 'wetter', 'witten'];
  // NRW grob nach Postleitzahl
  var NRW2 = ['32', '33', '40', '41', '42', '44', '45', '46', '47', '48', '50', '51', '52', '53', '57', '58', '59'];

  function parseAddr(a) {
    var parts = String(a || '').split(',').map(function (p) { return p.trim(); }).filter(Boolean);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i], m;
      if (/^\d{5}$/.test(p)) return { plz: p, city: clean(parts[i + 1] || '') };
      if ((m = p.match(/^(\d{5})\s+(.+)$/))) return { plz: m[1], city: clean(m[2]) };
    }
    return { plz: '', city: '' };
  }
  function clean(c) { c = c.replace(/^\d{5}\s*/, '').trim(); return /^deutschland$/i.test(c) ? '' : c; }
  function isRuhr(city) {
    var c = city.toLowerCase();
    for (var i = 0; i < RUHR.length; i++) { if (c === RUHR[i] || c.indexOf(RUHR[i] + ' ') === 0) return true; }
    return false;
  }
  function isNrw(plz) {
    if (!plz) return false;
    var p2 = plz.slice(0, 2), p3 = plz.slice(0, 3);
    if (NRW2.indexOf(p2) < 0) return false;
    if (p2 === '53' && (p3 === '534' || p3 === '535')) return false;
    if (p2 === '57' && (p3 === '575' || p3 === '576')) return false;
    return true;
  }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss'); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function init(root) {
    var dataEl = document.querySelector('script[data-rp-orgs]');
    var orgs = [];
    try { orgs = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { orgs = []; }
    orgs.forEach(function (o) {
      var a = parseAddr(o.a);
      o.city = a.city; o.plz = a.plz;
      o.ruhr = isRuhr(a.city); o.nrw = o.ruhr || isNrw(a.plz);
      o.key = norm(o.n + ' ' + o.city + ' ' + o.a);
      if (typeof o.lat === 'number' && typeof o.lon === 'number') {
        o.x = Math.round((o.lon - 5.6) / 9.7 * 300 * 10) / 10;
        o.y = Math.round((55.2 - o.lat) / 8.1 * 400 * 10) / 10;
      }
    });
    orgs.sort(function (a, b) { return a.n.localeCompare(b.n, 'de'); });

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var range = q('[data-rp-range]'), big = q('[data-rp-big]'), kids = q('[data-rp-kids]');
    var fCount = q('[data-rp-f-count]'), fOrg = q('[data-rp-f-org]'), fSlug = q('[data-rp-f-slug]');
    var sumCount = q('[data-rp-sum-count]'), sumOrg = q('[data-rp-sum-org]'), sumHint = q('[data-rp-sum-hint]'), sumLink = q('[data-rp-sum-orglink]');
    var list = q('[data-rp-list]'), dotsG = q('[data-rp-dots]'), search = q('[data-rp-q]'), empty = q('[data-rp-empty]'), status = q('[data-rp-status]');
    var sel = q('[data-rp-sel]');
    var state = { n: parseInt(root.getAttribute('data-default'), 10) || 25, region: 'all', term: '', cur: null };

    /* Anzahl */
    function setCount(n, fromRange) {
      n = Math.max(5, Math.min(100, Math.round(n / 5) * 5));
      state.n = n;
      if (range && !fromRange) range.value = n;
      if (range) {
        range.setAttribute('aria-valuetext', n + ' Schulranzen');
        range.style.setProperty('--p', ((n - 5) / 95 * 100) + '%');
      }
      if (big) big.textContent = n;
      if (kids) kids.textContent = n;
      if (fCount) fCount.value = n;
      if (sumCount) sumCount.textContent = n;
      qa('[data-rp-quick]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-rp-quick'), 10) === n)); });
    }
    if (range) range.addEventListener('input', function () { setCount(parseInt(range.value, 10), true); });
    qa('[data-rp-quick]').forEach(function (b) { b.addEventListener('click', function () { setCount(parseInt(b.getAttribute('data-rp-quick'), 10)); }); });

    /* Liste und Karte */
    var items = {}, dots = {};
    orgs.forEach(function (o) {
      var li = el('li'), btn = el('button', 'rp-item');
      btn.type = 'button'; btn.setAttribute('aria-pressed', 'false');
      if (o.l) { var img = el('img'); img.alt = ''; img.loading = 'lazy'; img.width = 44; img.height = 44; img.addEventListener('error', function () { img.replaceWith(el('span', 'rp-ph', o.n.charAt(0))); }); img.src = o.l; btn.appendChild(img); }
      else { btn.appendChild(el('span', 'rp-ph', o.n.charAt(0))); }
      var t = el('span'); t.appendChild(el('b', null, o.n)); if (o.city) t.appendChild(el('small', null, o.city)); btn.appendChild(t);
      btn.addEventListener('click', function () { choose(o, true); });
      li.appendChild(btn); list.appendChild(li); items[o.s] = { li: li, btn: btn };
      if (o.x != null && dotsG) {
        var g = document.createElementNS(NS, 'g');
        g.setAttribute('class', 'rp-dot'); g.setAttribute('tabindex', '0'); g.setAttribute('role', 'button');
        g.setAttribute('aria-label', o.n + (o.city ? ', ' + o.city : ''));
        var title = document.createElementNS(NS, 'title'); title.textContent = o.n + (o.city ? ', ' + o.city : '');
        var hit = document.createElementNS(NS, 'circle'); hit.setAttribute('class', 'rp-hit'); hit.setAttribute('cx', o.x); hit.setAttribute('cy', o.y); hit.setAttribute('r', 11);
        var pt = document.createElementNS(NS, 'circle'); pt.setAttribute('class', 'rp-pt'); pt.setAttribute('cx', o.x); pt.setAttribute('cy', o.y); pt.setAttribute('r', 6);
        g.appendChild(title); g.appendChild(hit); g.appendChild(pt);
        g.addEventListener('click', function () { choose(o, true); });
        g.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(o, true); } });
        dotsG.appendChild(g); dots[o.s] = g;
      }
    });
    var ring = null;
    if (dotsG) { ring = document.createElementNS(NS, 'circle'); ring.setAttribute('class', 'rp-ring'); ring.setAttribute('r', 12); ring.style.display = 'none'; dotsG.appendChild(ring); }

    function counts() {
      var c = { all: orgs.length, nrw: 0, ruhr: 0 };
      orgs.forEach(function (o) { if (o.nrw) c.nrw++; if (o.ruhr) c.ruhr++; });
      qa('[data-rp-cnt]').forEach(function (s) { s.textContent = '(' + c[s.getAttribute('data-rp-cnt')] + ')'; });
    }
    function match(o) {
      if (state.region === 'ruhr' && !o.ruhr) return false;
      if (state.region === 'nrw' && !o.nrw) return false;
      if (state.term && o.key.indexOf(state.term) < 0) return false;
      return true;
    }
    function filter() {
      var n = 0;
      orgs.forEach(function (o) {
        var ok = match(o); if (ok) n++;
        items[o.s].li.hidden = !ok;
        if (dots[o.s]) dots[o.s].classList.toggle('is-off', !ok);
      });
      empty.hidden = n > 0;
      if (status) status.textContent = n === 1 ? '1 Organisation gefunden' : n + ' Organisationen gefunden';
    }
    qa('[data-rp-region]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.region = b.getAttribute('data-rp-region');
        qa('[data-rp-region]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        filter();
      });
    });
    if (search) search.addEventListener('input', function () { state.term = norm(search.value.trim()); filter(); });

    function choose(o, focus) {
      state.cur = o;
      Object.keys(items).forEach(function (k) { items[k].btn.setAttribute('aria-pressed', String(k === (o && o.s))); });
      Object.keys(dots).forEach(function (k) { dots[k].classList.toggle('is-on', k === (o && o.s)); });
      if (ring) {
        if (o && o.x != null) { ring.setAttribute('cx', o.x); ring.setAttribute('cy', o.y); ring.style.display = ''; dotsG.appendChild(dots[o.s]); dotsG.appendChild(ring); }
        else ring.style.display = 'none';
      }
      if (!o) {
        sel.hidden = true;
        if (fOrg) fOrg.value = 'Noch offen, bitte beraten';
        if (fSlug) fSlug.value = '';
        if (sumOrg) sumOrg.textContent = 'eine Organisation eurer Wahl';
        if (sumHint) sumHint.hidden = false;
        if (sumLink) sumLink.textContent = 'Organisation wählen';
        return;
      }
      q('[data-rp-sel-name]').textContent = o.n;
      q('[data-rp-sel-city]').textContent = o.city || '';
      q('[data-rp-sel-desc]').textContent = o.d || '';
      q('[data-rp-sel-desc]').hidden = !o.d;
      var logo = q('[data-rp-sel-logo]');
      logo.onerror = function () { logo.hidden = true; };
      if (o.l) { logo.src = o.l; logo.hidden = false; } else { logo.removeAttribute('src'); logo.hidden = true; }
      var url = q('[data-rp-sel-url]');
      if (o.u && /^https?:\/\//i.test(o.u)) { url.href = o.u; url.hidden = false; } else { url.hidden = true; }
      sel.hidden = false;
      var label = o.n + (o.city ? ' (' + o.city + ')' : '');
      if (fOrg) fOrg.value = label;
      if (fSlug) fSlug.value = o.s;
      if (sumOrg) sumOrg.textContent = o.n;
      if (sumHint) sumHint.hidden = true;
      if (sumLink) sumLink.textContent = 'Organisation ändern';
      if (focus) {
        sel.focus({ preventScroll: true });
        var r = sel.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight - 120) sel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
    var clr = q('[data-rp-clear]');
    if (clr) clr.addEventListener('click', function () { choose(null); if (search) search.focus(); });

    counts(); filter(); setCount(state.n);

    /* Vorauswahl ?org=<Link-Kürzel> */
    try {
      var p = new URLSearchParams(location.search).get('org');
      if (p) {
        p = p.trim().toLowerCase();
        for (var i = 0; i < orgs.length; i++) { if (orgs[i].s === p) { choose(orgs[i], false); break; } }
      }
      var n = parseInt(new URLSearchParams(location.search).get('anzahl'), 10);
      if (n) setCount(n);
    } catch (e) { /* ältere Browser */ }

    /* Formular: Pflichtfelder prüfen, nichts weiter */
    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var first = null;
        qa('[data-rp-req]').forEach(function (inp) {
          var ok = inp.value.trim() !== '' && (inp.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim()));
          inp.setAttribute('aria-invalid', String(!ok));
          var msg = inp.parentNode.querySelector('.rp-ferr');
          if (msg) { msg.hidden = ok; if (!msg.id) msg.id = inp.id + '-err'; }
          if (!ok) inp.setAttribute('aria-describedby', msg.id); else inp.removeAttribute('aria-describedby');
          if (!ok && !first) first = inp;
        });
        if (first) { e.preventDefault(); first.focus(); }
      });
    }
    var ok = root.querySelector('[data-rp-ok]') || root.querySelector('[data-rp-errbox]');
    if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-rp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
